import { NonProfitWidgetContent } from './NonProfitWidgetContent';
import type { NonProfitWidgetProps } from './useNonProfitWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const NonProfitWidget = ({ status, data, handlers, hooks, isSingleBillChildAccount }: NonProfitWidgetProps) => {
  return (
    <WithStatusHandling
      skeletonHeight={62}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {status === 'loaded' && (
        <NonProfitWidgetContent
          data={data}
          handlers={handlers}
          hooks={hooks}
          isSingleBillChildAccount={isSingleBillChildAccount}
        />
      )}
    </WithStatusHandling>
  );
};
